/**
 * Clean this up along with platform_editor_ai_aifc_streaming
 */
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Tooltip from '@atlaskit/tooltip';
import { IconButton } from '@atlaskit/button/new';
import HistoryIcon from '@atlaskit/icon-lab/core/history';

import { useAIRovoButtonEnablement } from '@confluence/ai-floating-context-menu/entry-points/useAIRovoButtonEnablement.ts';

import { AnalyticContexts } from './analyticsUtils.tsx';

interface ShowDiffButtonProps {
	isShowDiffSelected: boolean;
	isShowDiffEnabled: boolean;
	onShowDiff: () => void;
}

const i18n = defineMessages({
	toggleShowDiffEditorLabel: {
		id: 'object-sidebar-components.toggle.show-diff.editor.label',
		defaultMessage: 'View changes',
		description: 'Label for button to toggle show diff in editor',
	},
});

export const ShowDiffButton = ({
	isShowDiffEnabled,
	isShowDiffSelected,
	onShowDiff,
}: ShowDiffButtonProps) => {
	const isRovoButtonEnabled = useAIRovoButtonEnablement();

	const analyticsContext = {
		source: AnalyticContexts.Source,
		name: `${AnalyticContexts.Source}ShowDiffButton`,

		attributes: {
			source: AnalyticContexts.Source,
			name: `${AnalyticContexts.Source}ShowDiffButton`,
			willSelectShowDiff: !isShowDiffSelected,
		},
	};

	return (
		<Tooltip
			position="left"
			content={<FormattedMessage {...i18n.toggleShowDiffEditorLabel} />}
			delay={0}
		>
			<IconButton
				icon={HistoryIcon}
				appearance="subtle"
				label=""
				testId="sidebar-show-diff-button"
				shape={isRovoButtonEnabled ? 'default' : 'circle'}
				onClick={() => {
					onShowDiff();
				}}
				tooltip={{
					position: 'left',
				}}
				isSelected={isShowDiffSelected}
				isDisabled={!isShowDiffEnabled}
				analyticsContext={analyticsContext}
			/>
		</Tooltip>
	);
};
